// @flow
import React from 'react'
import classNames from 'classnames'

type IconValueComponentProps = {
  active?: boolean,
  icon: string,
  id: string,
  name: string,
  onChange: (checked: boolean) => void,
  value: string,
}

const IconValueComponent = (props: IconValueComponentProps) => (
  <div className='custom-control custom-checkbox checkbox-image '>
    <input
      checked={props.active}
      className='custom-control-input'
      data-hj-whitelist
      id={props.id}
      name={props.name}
      onChange={(event: SyntheticInputEvent<HTMLInputElement>) => { props.onChange(event.target.checked) }}
      type='checkbox'
    />
    <label className={classNames(['custom-control-label', props.active ? 'text-primary' : ''])} htmlFor={props.id}>
      <span className='image'>
        <span className={props.icon}/>
      </span>
      <span className='label'><strong>{props.value}</strong></span>
    </label>
  </div>
)

export default IconValueComponent
